import React, { useCallback } from 'react';
import { ProductOption } from '../../../../apis/models/products/res/ProductOption';
import styled from 'styled-components';
import Typo from '../../../../components/atom/Typo';
import { formatCurrency } from '../../../../utils/utils';
import { ReactComponent as DepthIcon } from '../../../../assets/depth.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svgs/delete-item.svg';
import strings from '../../../../constants/strings.constants';
import useAuthStore from '../../../../store/useAuthStore';
export interface SelectedProductOptionItemProps {
  productOption: ProductOption;
  onDeleteClick?: (productOption: ProductOption) => void;
}
function SelectedProductOptionItem(props: SelectedProductOptionItemProps) {
  const { partner } = useAuthStore();
  const { productOption, onDeleteClick } = props;
  const {
    productOptionName,
    productOptionTotalDiscountPrice,
    productOptionTotalPrice,
  } = productOption;

  const getProductOptionOriginPriceText = useCallback(() => {
    if (productOptionTotalDiscountPrice && productOptionTotalPrice) {
      return `${formatCurrency(productOptionTotalPrice)}${strings.priceUnit}`;
    }
    return '';
  }, [productOptionTotalDiscountPrice, productOptionTotalPrice]);

  const customLabels = {
    zeroPriceLabel: partner?.productViewConfig?.zeroPriceReplaceText,
    needConsultationLabel: partner?.productViewConfig?.consultationReplaceText,
  };

  const getProductOptionPriceText = useCallback(() => {
    if (productOptionTotalDiscountPrice) {
      const price = formatCurrency(productOptionTotalDiscountPrice);
      if (customLabels.zeroPriceLabel && price == '0') {
        return customLabels.zeroPriceLabel;
      }

      return `${formatCurrency(productOptionTotalDiscountPrice)}${strings.priceUnit}`;
    }

    if (productOptionTotalPrice) {
      const price = formatCurrency(productOptionTotalPrice);
      if (customLabels.zeroPriceLabel && price == '0') {
        return customLabels.zeroPriceLabel;
      }

      return `${formatCurrency(productOptionTotalPrice)}${strings.priceUnit}`;
    }

    if (
      customLabels?.zeroPriceLabel &&
      (productOptionTotalPrice == 0 || productOptionTotalDiscountPrice == 0)
    ) {
      return customLabels.zeroPriceLabel;
    }

    if (customLabels.needConsultationLabel) {
      return customLabels.needConsultationLabel;
    }

    return strings.needConsultation;
  }, [
    productOptionTotalDiscountPrice,
    productOptionTotalPrice,
    customLabels.needConsultationLabel,
    customLabels.zeroPriceLabel,
  ]);

  const originPriceText = getProductOptionOriginPriceText();
  const priceText = getProductOptionPriceText();

  return (
    <ProductOptionWrapper>
      <div className="flex items-center gap-2">
        <div className="flex items-start gap-[3px] flex-1">
          <DepthIcon />
          <div className="flex flex-col gap-1">
            <Typo type="b-14">{productOptionName}</Typo>
            <div className="flex gap-1 items-center">
              {originPriceText && (
                <div>
                  <Typo
                    type="r-14"
                    color="#AEB4BF"
                    style={{
                      textDecoration: 'line-through',
                    }}
                  >
                    {originPriceText}
                  </Typo>
                </div>
              )}
              <Typo type="r-14">{priceText}</Typo>
            </div>
          </div>
        </div>
        <DeleteButton
          onClick={() => {
            if (onDeleteClick) onDeleteClick(productOption);
          }}
        >
          <DeleteIcon />
        </DeleteButton>
      </div>
    </ProductOptionWrapper>
  );
}

export default SelectedProductOptionItem;

const ProductOptionWrapper = styled.div`
  background-color: ${(props) => {
    return 'white';
  }};
  transition: background-color 0.2s;
`;

const DeleteButton = styled.button``;
